export default {
  title: 'light',

  gray: 0,
  colors: {
    primary: '#0071BD',
    secondary: '#47AAEB',
    disable01: '#BBDCF1',
    success: '#7AC943',
    success02: '#00BA9C',
    aqua: '#00BA9C',
    disable02: '#C1F59D',
    danger: '#FF5A66',
    danger02: '#FC1929',
    disable03: '#F4D4D6',
    warning: '#F29423',
    tertiary: '#F9EC22',
    attention: '#9354E6',
    detail: '#FD8BD1',
    gray01: '#F2F2F2',
    gray02: '#E8E8E8',
    gray03: '#959595',
    gray04: '#707070',
    gray05: '#3f3f3f',
    gray06: '#dddddd',
    gray07: '#333333',
    gray08: '#cccccc',
    gray09: '#f2f2f2',
    disable04: '#E6E6E6',
    backgroundColor: '#FFFFFF',

    shadow01: '#00000029',

    purple01: '#331e54',

    white01: '#ffffff',
    black01: '#000000',

    orange01: '#c26565',
    orange02: '#953b39',
    orange03: '#D75413',

    green01: '#739e73',
    green02: '#659265',
    green03: '#00352c',

    blue01: '#3276b1',
    blue02: '#002147',
    blue03: '#0095dd',
    blue04: '#00539f',

    text: {
      primary: '#707070',
      secondary: '#959595',
      tertiary: '#FFFFFF',
      gray05: '#E6E6E6',
      attention: '#9354E6',
      warning: '#F29423',
      danger: '#FF5A66',
      danger03: '#F4D4D6',
      success: '#7AC943',
      success02: '#C1F59D',
      aqua: '#C1F59D',
      info01: '#47AAEB',
      info02: '#0071BD',
      info03: '#BBDCF1',
    },
  },
};
